export const heroData = {
  title: "必赢亚洲·官方正版平台",
  subtitle: "亚洲顶级娱乐游戏平台，安全畅玩赢无止境",
  stats: [
    { value: "10,000,000+", label: "注册会员" },
    { value: "1,000+", label: "精品游戏" },
    { value: "24/7", label: "客服在线" },
    { value: "99.9%", label: "用户好评" },
  ],
};

export const gameCategories = [
  {
    id: "sports",
    name: "体育竞技",
    icon: "ri-football-line",
    description: "覆盖全球主流赛事，实时赔率更新，足球、篮球、网球等热门体育项目一应俱全",
    features: ["实时赔率", "赛事直播", "多种玩法", "快速结算"],
    image: "https://readdy.ai/api/search-image?query=A%20luxurious%20golden%20sports%20arena%20with%20dramatic%20stadium%20lighting%2C%20soccer%20ball%20on%20field%20with%20golden%20glow%2C%20elegant%20dark%20background%20with%20ambient%20gold%20particles%2C%20premium%20sports%20atmosphere%2C%20professional%20sports%20photography%20style%20with%20warm%20golden%20tones%20and%20deep%20shadows%2C%20luxurious%20and%20dramatic%20composition&width=800&height=500&seq=sports-category-001&orientation=landscape",
  },
  {
    id: "live",
    name: "真人娱乐",
    icon: "ri-live-line",
    description: "真人荷官在线发牌，高清直播无延迟，百家乐、轮盘、骰宝等经典玩法随时畅享",
    features: ["真人荷官", "高清直播", "多台选择", "互动体验"],
    image: "https://readdy.ai/api/search-image?query=A%20luxurious%20casino%20interior%20with%20elegant%20golden%20decorations%2C%20professional%20card%20table%20with%20warm%20ambient%20lighting%2C%20dark%20rich%20background%20with%20gold%20accents%2C%20premium%20and%20sophisticated%20atmosphere%2C%20dramatic%20lighting%20with%20golden%20highlights%2C%20professional%20interior%20photography%20style%20with%20deep%20contrast&width=800&height=500&seq=live-casino-001&orientation=landscape",
  },
  {
    id: "slots",
    name: "电子游艺",
    icon: "ri-gamepad-line",
    description: "海量精品游戏，精美画面流畅体验，老虎机、捕鱼、棋牌等丰富选择应有尽有",
    features: ["3D画面", "高额奖池", "丰富主题", "流畅体验"],
    image: "https://readdy.ai/api/search-image?query=A%20vibrant%20luxurious%20gaming%20display%20with%20colorful%20slot%20machine%20reels%20and%20golden%20decorative%20elements%2C%20dark%20elegant%20background%20with%20warm%20golden%20glow%20effects%2C%20premium%20gaming%20atmosphere%20with%20sparkling%20lights%2C%20professional%20product%20photography%20style%20with%20rich%20colors%20and%20dramatic%20lighting&width=800&height=500&seq=slots-games-001&orientation=landscape",
  },
];

export const features = [
  {
    id: "safety",
    icon: "ri-shield-check-line",
    title: "安全可靠",
    description: "官方正版授权，采用国际领先的多重加密技术，全方位保障您的资金安全与个人信息隐私",
  },
  {
    id: "speed",
    icon: "ri-flashlight-line",
    title: "极速到账",
    description: "存取款秒级响应处理，支持多种主流支付方式，随时随地自由充值提现，资金流转无障碍",
  },
  {
    id: "service",
    icon: "ri-customer-service-2-line",
    title: "24小时客服",
    description: "全天候专业客服团队在线待命，多渠道即时响应，随时为您解答疑问、处理问题",
  },
  {
    id: "fair",
    icon: "ri-scales-line",
    title: "公平公正",
    description: "采用国际认证的随机数生成算法，每一局游戏结果均经过严格审计，确保绝对公平透明",
  },
  {
    id: "odds",
    icon: "ri-line-chart-line",
    title: "高赔率体系",
    description: "行业领先的赔率定价体系，实时跟踪国际市场变化，让您的每一注都能获得最优回报",
  },
  {
    id: "variety",
    icon: "ri-stack-line",
    title: "玩法丰富",
    description: "汇聚体育竞技、真人娱乐、电子游艺三大板块，提供超过一千款精品游戏任您挑选",
  },
];

export const promotions = [
  {
    id: "newbie",
    title: "新会员首存礼",
    description: "首次充值即享100%赠送，最高可获888元彩金，助您开启幸运之旅",
    icon: "ri-gift-line",
    badge: "热门",
  },
  {
    id: "rebate",
    title: "每日返水",
    description: "体育投注享0.8%返水，真人娱乐享0.6%返水，电子游艺享1.2%返水，上不封顶",
    icon: "ri-refresh-line",
    badge: "推荐",
  },
  {
    id: "vip",
    title: "VIP专属福利",
    description: "VIP会员专享生日礼金、专属客服经理、优先提现通道、专属活动邀请等尊贵特权",
    icon: "ri-vip-crown-line",
    badge: "尊享",
  },
  {
    id: "invite",
    title: "邀请有礼",
    description: "邀请好友注册并完成首次充值，双方各得58元奖励金，邀请越多奖励越多",
    icon: "ri-user-add-line",
    badge: "限时",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "张先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20male%20portrait%20in%20business%20attire%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20studio%20background%20with%20soft%20gradient%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-male-01&orientation=squarish",
    rating: 5,
    comment: "在必赢亚洲玩了快两年了，提现速度真的没话说，一般几分钟就到账了。体育赔率也很公道，比很多平台都高，强烈推荐！",
    date: "2024-12-15",
  },
  {
    id: 2,
    name: "李女士",
    avatar: "https://readdy.ai/api/search-image?query=A%20professional%20Chinese%20female%20portrait%20with%20elegant%20style%2C%20warm%20lighting%2C%20confident%20smile%2C%20clean%20studio%20background%20with%20soft%20gradient%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-female-01&orientation=squarish",
    rating: 5,
    comment: "真人娱乐的画面太清晰了，荷官也专业。客服服务态度特别好，有一次半夜遇到问题，客服秒回帮我解决了，非常满意！",
    date: "2024-11-28",
  },
  {
    id: 3,
    name: "王先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20mature%20Chinese%20male%20portrait%20in%20casual%20elegant%20attire%2C%20warm%20studio%20lighting%2C%20relaxed%20genuine%20smile%2C%20clean%20professional%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-male-02&orientation=squarish",
    rating: 5,
    comment: "朋友推荐来的，注册就送了首存礼金。电子游艺种类真的多，画面也很精美。最关键是存取款都很快，玩得放心！",
    date: "2025-01-05",
  },
  {
    id: 4,
    name: "陈先生",
    avatar: "https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20portrait%20with%20modern%20stylish%20look%2C%20warm%20studio%20lighting%2C%20friendly%20approachable%20expression%2C%20clean%20professional%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-male-03&orientation=squarish",
    rating: 4,
    comment: "用了好几个平台，必赢亚洲的界面最好看，操作也流畅。体育赛事覆盖很全，五大联赛、NBA都有，够我玩的了。",
    date: "2025-01-18",
  },
];

export const faqData = [
  {
    id: 1,
    question: "如何注册必赢亚洲账号？",
    answer: "点击页面右上角的「立即注册」按钮，填写手机号码、设置登录密码，完成短信验证即可成功注册。整个注册过程只需1分钟，简单快捷。",
  },
  {
    id: 2,
    question: "必赢亚洲支持哪些充值方式？",
    answer: "我们支持多种主流充值方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等，满足不同用户的支付习惯，充值实时到账。",
  },
  {
    id: 3,
    question: "提现需要多久到账？",
    answer: "必赢亚洲采用智能审核系统，小额提现通常在5分钟内到账，大额提现经人工审核后30分钟内到账。我们承诺所有提现在2小时内处理完毕。",
  },
  {
    id: 4,
    question: "必赢亚洲是否有手机APP？",
    answer: "有的！我们提供iOS和Android双平台APP，您可以在官网直接下载。APP与网页端数据互通，随时随地畅享游戏乐趣。",
  },
  {
    id: 5,
    question: "游戏结果是否公平？",
    answer: "必赢亚洲所有游戏均采用国际认证的随机数生成算法（RNG），确保游戏结果完全随机、公平公正。我们定期接受第三方机构的审计和认证。",
  },
  {
    id: 6,
    question: "遇到问题如何联系客服？",
    answer: "我们提供7×24小时全天候客服服务，您可以通过在线客服聊天、官方客服电话、微信客服等多种渠道联系我们，专业客服团队随时为您服务。",
  },
];

export const aboutData = {
  brand: {
    title: "品牌介绍",
    content: [
      "必赢亚洲成立于2015年，总部位于菲律宾马尼拉，是亚洲领先的在线娱乐游戏平台。凭借卓越的技术实力和优质的客户服务，必赢亚洲已发展成为亚洲娱乐行业的标杆品牌。",
      "作为持有菲律宾PAGCOR合法牌照的正规运营商，必赢亚洲始终秉持「公平、公正、公开」的核心价值观，为全球超过千万注册会员提供安全可靠的娱乐游戏服务。我们的平台涵盖体育竞技、真人娱乐、电子游艺三大核心板块，拥有超过1000款精品游戏。",
      "必赢亚洲拥有一支由超过500名专业人才组成的团队，涵盖技术研发、产品运营、客户服务、风险管理等多个领域。我们持续投入技术创新，采用先进的加密技术和安全防护体系，确保每一位玩家的资金安全和个人隐私得到最严格的保护。",
    ],
    highlights: [
      { value: "2015年", label: "成立时间" },
      { value: "1000万+", label: "注册会员" },
      { value: "500+", label: "专业团队" },
      { value: "PAGCOR", label: "合法牌照" },
    ],
  },
  reputation: {
    title: "信誉口碑",
    content: [
      "必赢亚洲深耕亚洲市场近十年，凭借卓越的服务品质和诚信经营，赢得了广大玩家的信赖与好评。我们连续多年获得「亚洲最佳在线娱乐平台」、「最受玩家信赖品牌」等行业殊荣。",
      "在资金安全方面，必赢亚洲采用银行级加密技术，所有资金流转均受到严格监管。我们承诺「存取款2小时内到账」，实际平均到账时间远低于此标准，创造了行业领先的服务水准。",
      "我们的公平性得到了国际权威机构的多重认证。所有游戏算法均通过BMM Testlabs和GLI等国际认证机构的检测，确保游戏结果完全随机、不可操控。",
    ],
  },
  contact: {
    title: "联系我们",
    email: "service@biyingyazhou.com",
    phone: "+63-2-8888-6666",
    wechat: "biyingyazhouVIP",
    address: "菲律宾马尼拉市马卡蒂区商务中心",
    workingHours: "7×24小时 全天候服务",
  },
};